export default {
  clearSearch: 'Clear Search',
  search: 'Search',
  ok: 'OK',
  all: 'All',
  appleStore: 'Apple Store',
  reward: 'REWARD ',
  rmb: '￥',
  serverError: '系統錯誤，請聯系管理員'
}
